import { Check } from '../../components/ui/icons';

export function LiveCountBadge({ count, label }: { count: number; label: string }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-accent-wash px-2 py-[2px]">
      <span className="h-[5px] w-[5px] animate-h2h-pulse rounded-full bg-accent" />
      <span className="text-[9.5px] font-extrabold tracking-wide text-accent-ink">
        {count} {label}
      </span>
    </span>
  );
}

export function SoonBadge() {
  return (
    <span className="rounded-full bg-[rgba(225,160,40,0.14)] px-2 py-[2px] text-[9.5px] font-extrabold tracking-wide text-[#9A6B12]">
      SOON
    </span>
  );
}

export function JoinedPill() {
  return (
    <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-accent-wash px-[9px] py-[5px]">
      <Check width={11} height={11} strokeWidth={3.2} className="text-accent-ink" />
      <span className="text-[10.5px] font-extrabold text-accent-ink">Joined</span>
    </span>
  );
}
